import { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import produce from 'immer'
import {
  Modal as AntModal,
  Button,
  Input,
  Form as AntForm,
  Col,
  Divider,
  notification
} from 'antd'
import { useForm, Controller, FormProvider, get } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

import * as ROUTES from 'admin/routes'
import { useApi } from 'admin/lib/Api'

export function EditAccount({ account, isNew, accountId }) {
  const navigate = useNavigate()
  const [submitting, setSubmitting] = useState(false)

  //
  // Form setup & values

  const draftItem = isNew ? blankAccount : account

  const form = useForm({
    defaultValues: draftItem,
    mode: 'all',
    criteriaMode: 'firstError'
  })

  //
  // Callbacks

  const api = useApi()
  const onSubmit = useCallback(
    async data => {
      setSubmitting(true)

      const submissionData = produce(draftItem, draft => {
        draft.name = data.name
      })

      const [, status, error] = isNew
        ? await api.registerAccount(data.name)
        : await api.updateAccount(submissionData)

      if (error) {
        AntModal.error({
          title: 'Error Saving Account',
          content: (
            <>
              <p>Error, you may wish to try again. </p>
              <p>{`Details: ${status}: ${error}`}</p>
            </>
          )
        })
      } else {
        setSubmitting(false)
        navigate(ROUTES.ACCOUNTS.LIST)
        notification.success({
          message: 'Successfully saved account'
        })
      }
    },
    [api, draftItem, isNew, navigate]
  )

  return (
    <AntForm layout="vertical" onFinish={form.handleSubmit(onSubmit)}>
      <FormProvider {...form}>
        <Controller
          name="name"
          rules={{
            required: true
          }}
          render={controller => (
            <AntForm.Item
              label="Account Name [eg. TSmail Ltd.]"
              {...getErrorProps(controller.name, form.errors)}
            >
              <Input {...controller} />
            </AntForm.Item>
          )}
        />

        <Divider type="horizontal" />

        <Col align="middle">
          <Button type="primary" htmlType="submit" disabled={submitting}>
            {isNew ? 'Create' : 'Update'}
          </Button>
        </Col>
      </FormProvider>
    </AntForm>
  )
}

const blankAccount = {
  name: ''
}

EditAccount.propTypes = {
  account: PropTypes.object,
  isNew: PropTypes.bool.isRequired
}

function getErrorProps(name, errors) {
  const error = get(errors, name, null)

  if (error) {
    return {
      hasFeedback: true,
      validateStatus: 'error'
    }
  } else {
    return {}
  }
}
